import { Component } from '@angular/core';
import { StorageProvider } from '../../providers/storage-service/storage-service';
import { NavController, NavParams } from 'ionic-angular';


@Component({
    selector: 'score-board-modal-wallen',
    templateUrl: 'score-board-wallen.html'
  })

  export class ScoreBoardWallen {

    // scoreBoardArray = [];
    wallenArray = [];
    isWallen: boolean = false;

      constructor (private storage: StorageProvider,
        private navCtrl: NavController, private navParams: NavParams) {
        // this.getAthletes();
        this.getArray();
      }
      // async getAthletes(){
      //   await this.storage.getSaved('score-board').then((data) => this.scoreBoardArray = data);
      //   console.log("athletes" + this.scoreBoardArray);
      // }
      async getArray() {
         this.wallenArray = this.wallenArray.concat(this.navParams.get('array'));
         this.isWallen = true;
         console.log("ath wallen arr " + JSON.stringify(this.wallenArray));
      }

      onBackMenu() {
        this.wallenArray.length = 0;
        this.navCtrl.pop();
      }
  }


// WEBPACK FOOTER //
// /src/components/score-board-wallen/score-board-wallen.ts